import { createFormAction } from "redux-form-saga";
export const ADJUSTMENT_FORM_KEY = 'ASSET_ADJUSTMENT_FORM'
export const AssetAdjustmentFormAction = createFormAction(ADJUSTMENT_FORM_KEY)

